<template>
  <svg-icon :class="validType" name="manager"></svg-icon>
</template>

<script>

import '../../distribution/icons/manager';

export default {
  props: {
    type: String
  },
  data() {
    return {
      availableTypes: ['blue', 'orange'],
      defaultType: 'orange'
    };
  },
  computed: {
    validType() {
      return this.availableTypes.includes(this.type) ? this.type : this.defaultType;
    }
  }
};
</script>

<style scoped lang="scss">
.orange /deep/ {
  .fill-primary {
    fill: var(--secondary);
  }
  .fill-secondary {
    fill: var(--white);
  }
}

.blue /deep/ {
  .fill-primary {
    fill: var(--blue);
  }
  .fill-secondary {
    fill: var(--white);
  }
}
</style>
